import * as React from "react";
import { getItemGroupData } from "../../../Helpers/table";
import { AttributeGroup, DataGridContent, ExportColumn } from "../../../Models";
import SearchDataGrid from "../DataGrid/SearchDataGrid";

type PaginatedItemGroupProps = {
    attributeGroup: AttributeGroup;
    defaultPageSize?: number;
    columnEditable: boolean;
    filterable: boolean;
    isSortable: boolean;
    searchIndex: string;
    exportColumns?: ExportColumn[];
    latestAction: string;
    removedColumns: string[];

    // onReactTableColumnReOrder?: (columns: any) => void;
    // onReactTableSort?: (sort: any) => void;
    // onReactTableFilter?: (filters: any) => void;
    // onSetRemovedColumns?: (columns: string[]) => void;
};

export default function PaginatedItemGroup(props: PaginatedItemGroupProps) {
    const dataGridContent: DataGridContent = getItemGroupData(
        props.attributeGroup.headers,
        props.attributeGroup.rows
    );
    return (
        <div className="ItemGroup">
            <h3 className="ItemGroup__title">{props.attributeGroup.name}</h3>

            <SearchDataGrid
                filterable={props.filterable}
                isSortable={props.isSortable}
                showPagination={true}
                filterableColumns={props.attributeGroup.filterableColumns}
                columnEditable={props.columnEditable}
                // onReactTableFilter={props.onReactTableFilter}
                // onReactTableSort={props.onReactTableSort}
                // onReactTableColumnReOrder={props.onReactTableColumnReOrder}
                // onSetRemovedColumns={props.onSetRemovedColumns}
                defaultPageSize={
                    props.defaultPageSize ? props.defaultPageSize : 20
                }
                searchIndex={props.searchIndex}
                content={dataGridContent}
                exportColumns={props.exportColumns}
                latestAction={props.latestAction}
                removedColumns={props.removedColumns}
            />
        </div>
    );
}
